<template>
  <v-container class="pa-0" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-data-table :headers="headers" :items="lines" hide-actions no-data-text="Данные отсутствуют">
        <template slot="items" slot-scope="{item, index}">
          <td v-html="item.name"></td>
          <td class="text-xs-center">
            <div :style="{height:'25px',width:'45px',background:item.color}" @click="showColorPicker($event, index)"></div>
          </td>
          <td class="text-xs-center pa-0 ma-0">
            <v-btn color="info" class="ma-0" icon flat @click="editLine(item)"><v-icon>mdi-pencil</v-icon></v-btn>
            <v-btn color="error" class="ma-0" icon flat @click="deleteLine(index)"><v-icon>mdi-delete</v-icon></v-btn>
          </td>
        </template>
      </v-data-table>
      <span class="dashed pointer pull-right my-2" @click="showPanel=!showPanel">{{showPanel?'Свернуть панель':'Добавить линию'}}</span>
    </v-flex>
  </v-layout>
    <v-layout row wrap v-show="showPanel">
      <v-flex xs12 sm5>
        <p class="body-2 mb-1">Признаки</p>
        <v-treeview v-model="tree" :items="objects" selected-color="primary" selectable return-object>
          <template slot="prepend" slot-scope="{ item, open, leaf }">
            <v-icon size="20" class="mx-0" :color="item.iconcolor">{{item.icon}}</v-icon>
          </template>
          <label slot="label" class="pointer" slot-scope="{item}" @click="">{{item.name}}</label>
        </v-treeview>
      </v-flex>
      <v-flex xs12 sm1 style="position: relative">
        <v-menu offset-y style="position: sticky; top: 40%;">
          <v-btn slot="activator" icon color="secondary"><v-icon>mdi-arrow-right</v-icon></v-btn>
          <v-list>
            <v-list-tile @click="addObject(0)">
              <v-list-tile-title>Только выбранные</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="addObject(1)">
              <v-list-tile-title>Все вхождения</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm6>
        <p class="body-2 mb-1">Результат</p>
        <v-alert v-model="existError" dismissible transition="fade-transition" outline>
          {{errorMessage}}
        </v-alert>
        <v-list>
          <v-list-tile v-for="(item, index) in lineObjects" :key="index" class="object-list">
            <v-list-tile-content>
              <v-list-tile-sub-title v-html="item.name"></v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn icon @click="deleteObject(index)"><v-icon color="error">delete</v-icon></v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        <v-btn small color="success" class="ml-0" @click="addLine">{{this.selectedLine ? 'Сохранить' : 'Добавить'}} линию</v-btn>
      </v-flex>
    </v-layout>
  
    <v-menu
      v-model="showMenu"
      :position-x="menu.x"
      :position-y="menu.y"
      absolute
      :close-on-content-click="false"
      offset-y
    >
      <photoshop-picker
        head="Выбор цвета"
        cancelLabel="Отмена"
        newLabel="Текущий"
        currentLabel="Другой"
        v-model="colors"
        @ok="setColor"
        @cancel = "showMenu=false"
        style="width: auto; height: auto;"
      ></photoshop-picker>
    </v-menu>
  </v-container>
</template>

<script>
  import { Photoshop } from "vue-color"
  
  export default {
    name : "LineConstructor",
  
    components: {
      'photoshop-picker': Photoshop
    },
    
    props:{
      objects: {
        type: Array,
        required: false,
        default: () => []
      },
      value: {
        type: Array,
        required: false,
        default: () => []
      },
    },
  
    computed:{
      lines:{
        get(){ return this.value },
        set(v){}
      },
    },
    
    data(){
      return {
        headers: [
          { text: 'Линия', align: 'left', sortable: false },
          { text: 'Цвет', align: 'center', sortable: false, width: 40 },
          { text: 'Действия', align: 'center', sortable: false, width: 100 },
        ],
        showPanel: false,
        showMenu: false,
        menu:{ x:0, y:0, index: false },
        tree: [],
        lineObjects: [],
        existError: false,
        errorMessage: '',
        colors:  "#0288d1",
        selectedLine: null,
      }
    },
    
    methods:{
      computeObjectName(item){
        item.name = ''
        if(item.type===1){
          item.name = '<i aria-hidden="true" class="v-icon mdi mdi-sigma" style="font-size:20px"></i>('
        }
        item.properties.map( (obj, ind) => {
          let sep = (ind===item.properties.length-1) ? '' : '->'
          item.name+= obj.name + sep
        })
        if(item.type===1) item.name+=')'
      },
      
      computeLineName(objects){
        let name = ''
        objects.map( (item,index) => {
          let amp = (index!==objects.length-1) ? '<i aria-hidden="true" class="v-icon mdi mdi-ampersand" style="font-size:17px"></i>' : ''
          name+=item.name+amp
        })
        return name
      },
  
      showColorPicker(event, index){
        this.menu = {
          x: event.x,
          y: event.y,
          index
        }
        this.colors = this.lines[index].color
        this.showMenu = true
      },
  
      setColor(){
        this.lines[this.menu.index].color = this.colors.hex
        this.showMenu = false
      },
      
      addLine(){
        if(this.lineObjects.length>0){
          if(this.selectedLine){
            let index = this.lines.findIndex(line => line.uniq===this.selectedLine)
            if(index>-1){
              this.lines[index].name = this.computeLineName(this.lineObjects)
              this.lines[index].line = this.lineObjects
            }
          } else {
            this.lines.push({
              id: '',
              name: this.computeLineName(this.lineObjects),
              color: this.generateColor(),
              line: this.lineObjects,
              uniq: this.generateUniq()
            })
          }
        }
        this.selectedLine = null
        this.lineObjects = []
        this.$emit('input', this.lines)
      },
  
      editLine(item){
        //Новый uniq нужен для случая если форма только открыта. И ей не присвоено никакого uniq
        let uniq = this.generateUniq()
        item.uniq = uniq
        this.selectedLine = uniq
        this.lineObjects = item.line
        this.lineObjects.map( obj => {
          this.computeObjectName(obj)
        })
        this.showPanel = true
      },
      
      deleteLine(index){
        this.lines.splice(index,1)
        this.$emit('input', this.lines)
      },
      
      addObject(type){
        let data = []
        this.tree.map( item => {
          if(item.element_type!=='folder'){
            if(item.element_type==='property'){
              data.push({element_type: item.element_type, property_id: item.id, identified: item.name, name: item.name})
            } else {
              data.push({element_type: item.element_type, identified: item.id, name: item.name})
            }
          }
        })
        let obj = {type: type, properties: data, name: name};
        this.computeObjectName(obj)
        this.lineObjects.push(obj)
        this.tree = []
      },
      
      deleteObject(index){
        this.lineObjects.splice(index, 1)
      },
      
      generateUniq(){
        return (Math.floor(Math.random()*1679615)+1).toString(36)
      },
      
      generateColor(){
        return '#'+ ('000000' + Math.floor(Math.random()*16777215).toString(16)).slice(-6)
      }
    }
  }
</script>

<style>
  .object-list .v-list__tile {
    padding: 0 !important;
  }
</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Common/LineConstructor.vue